import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Container, Grid } from "@material-ui/core";
import {
  SimpleLoading,
  PromotionalFooterPure,
  ButtonAddHLPure,
} from "../../pures";
import {
  HeaderHLPure,
  ButtonHLPure,
  FilterHLPure,
  GridHLPure,
  SearchBarHLPure,
  DialogYesNoHLPure,
  DialogSystemGLPure,
  DropDownBtnHLPure,
  LabelModalPure,
} from "../../pures";
import "./user-administration.view.css";
import UserAdministrationConfigurationsView from "./user-administration-pages/user-administration-configurations.view";
import useMediaQuery from '@material-ui/core/useMediaQuery'
import { UserService } from '../../../services'

const UserAdministrationView = (props) => {
  const {
    usersCollaboratorAdmin,
    optionsFilter,
    rolesBySignatureProfile,
    deleteUser,
    handleCloseDialogDelete,
    showDialogDelete,
    handleShowDialogDelete,
  } = props;
  const { t } = useTranslation();
  const [dataUser, setDataUser] = useState(usersCollaboratorAdmin);
  const [selectedValueFilter, setSelectedValue] = useState('todos')
  const [searchValue, setSearchValue] = useState("");
  const [selectedUser, setSelectedUser] = useState({});
  const [showDetails, setShowDetails] = useState(false);
  const [nameComponentUser, setNameComponentUser] = useState("");
  const [headerTitleinDetail, setHeaderTitleinDetail] = useState({
    clicked: false,
    name: "",
  });
  const [showResendInvitationConfirm, setShowResendInvitationConfirm] = useState(false);
  const [resendInvitationUser, setResendInvitationUser] = useState(null);
  const userInvitedService = new UserService(
    process.env.REACT_APP_MIFIRMA_API
  )
  const isMobile = useMediaQuery('(max-width:1025px)')
  const isMobileHorizontal = useMediaQuery('(max-width:1200px) and (orientation: landscape)')
  const isCompactView = isMobile || isMobileHorizontal

  //Filter Function, get selected value
  const filterChange = (e) => {
    const selectedOption = e.target.value
    setSelectedValue(selectedOption)
  };

  //Search Function, get value search input
  const searchChange = (e) => {
    e.preventDefault();
    setSearchValue(e.target.value);
  };

  // Combined Filter and Search logic - single source of truth
  useEffect(() => {

    if (!usersCollaboratorAdmin || usersCollaboratorAdmin.length === 0) {
      setDataUser([])
      return
    }

    let filteredData = [...usersCollaboratorAdmin]

    // Apply filter first
    if (selectedValueFilter === 'activo') {
      filteredData = filteredData.filter((user) => user.active === true)
    } else if (selectedValueFilter === 'inactivo') {
      filteredData = filteredData.filter((user) => user.active === false)
    }

    // Then apply search
    if (searchValue && searchValue.trim() !== '') {
      filteredData = filteredData.filter((user) => {
        const searchLower = searchValue.toLowerCase();
        return (
          (user.name && user.name.toLowerCase().includes(searchLower)) ||
          (user.email && user.email.toLowerCase().includes(searchLower))
        )
      })
    }

    setDataUser(filteredData)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchValue, selectedValueFilter, usersCollaboratorAdmin])

  const setHeaderTitle = () => {
    const name = headerTitleinDetail.name || nameComponentUser;
    switch (name) {
      case "":
        return t("userAdministrationView.title");
      case t("userAdministrationView.grid.actions.assign.roles"):
        return t("userAdministrationView.roleAssignTitle");
      case t("userAdministrationView.grid.actions.assign.companies"):
        return t("userAdministrationView.enterpriseAssignTitle");
      case t("userAdministrationView.grid.actions.disable"):
        return t("userAdministrationView.disableUserTitle");
      case "Agregar usuario":
        return t("userAdministrationView.saveUserTitle");
      default:
        return t("userAdministrationView.title");
    }
  };

  useEffect(() => {
    if (headerTitleinDetail.clicked) {
      setHeaderTitle();
    }
    setHeaderTitle();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nameComponentUser, headerTitleinDetail]);

  /**
   * @function handleResendInvitationClick
   * @description Muestra modal de confirmación para reenviar invitación
   * @param {Object} dataItem - Usuario al que se reenviará la invitación
   * @returns {void}
   */
  const handleResendInvitationClick = (dataItem) => {
    setResendInvitationUser(dataItem);
    setShowResendInvitationConfirm(true);
  };

  /**
   * @function handleResendInvitationClose
   * @description Cierra el modal de reenviar invitación sin realizar cambios
   * @returns {void}
   */
  const handleResendInvitationClose = () => {
    setShowResendInvitationConfirm(false);
    setResendInvitationUser(null);
  };

  /**
   * @function handleResendInvitationSubmit
   * @description Ejecuta el reenvío de invitación después de confirmar
   * @returns {Promise<void>}
   */
  const handleResendInvitationSubmit = async () => {
    setShowResendInvitationConfirm(false);
    props.toggleLoadingRequesting(true);

    try {
      const response = await userInvitedService.resendCollaboratorInvitation(
        props.token,
        resendInvitationUser.email
      );

      if (response && response.statusCode === 200) {
        if (props.forceRefresh) {
          props.forceRefresh()
        }
        props.toggleLoadingRequesting(false);
        props.toggleCompletedRequesting(true);
        if (props.setMessage) {
          props.setMessage(
            response.message || t('administrateInvitedUsers.resendInvitation.success')
          )
        }
      } else {
        throw new Error(response.message || t('administrateInvitedUsers.resendInvitation.error'))
      }
    } catch (error) {
      console.error('Error resending invitation:', error);
      props.toggleLoadingRequesting(false);
      props.toggleErrorRequesting(true);
      if (props.setMessage) {
        props.setMessage(
          error.message || t('administrateInvitedUsers.resendInvitation.error')
        );
      }
    }

    setResendInvitationUser(null);
  };

  return (
    <div className="standard-wrapper">
      {props.loading ? (
        <SimpleLoading />
      ) : (
        <Container
          lg={12}
          md={12}
          spacing={4}
          className="userAdministrationView-container"
        >
          {showDetails && nameComponentUser ? (
            <UserAdministrationConfigurationsView
              nameComponentUser={nameComponentUser}
              selectedUser={selectedUser}
              hideShowDetails={() => {
                setShowDetails(false);
                setNameComponentUser("");
                setHeaderTitleinDetail({ clicked: false, name: "" });
              }}
              userAdmin={props?.user?.userMetaData?.userMifirma?.email}
              token={props.token}
              rolesBySignatureProfile={rolesBySignatureProfile}
              setHeaderTitleinDetail={setHeaderTitleinDetail}
              validators={props.validators}
              forceRefresh={props.forceRefresh}
              setShowDetails={setShowDetails}
              usersCollaboratorAdmin={usersCollaboratorAdmin}
              showErrorRequesting={props.showErrorRequesting}
              showLoadingRequesting={props.showLoadingRequesting}
              showCompletedRequesting={props.showCompletedRequesting}
              showWarningRequesting={props.showWarningRequesting}
              toggleWarningRequesting={props.toggleWarningRequesting}
              toggleLoadingRequesting={props.toggleLoadingRequesting}
              toggleCompletedRequesting={props.toggleCompletedRequesting}
              toggleErrorRequesting={props.toggleErrorRequesting}
              setNameComponentUser={setNameComponentUser}
              message={props.message}
              t={t}
              {...props}
            />
          ) : (
            <>
              {/**HEADER Container**/}
              <Grid
                item
                lg={12}
                md={12}
                xs={12}
                sm={12}
                className="userAdministrationView-header"
              >
                <HeaderHLPure title={t("userAdministrationView.title")} />
              </Grid>
              <div className='userAdministrationView-navbar'>
                <div className='userAdministrationView-buttonHLPure'>
                  <ButtonAddHLPure
                    nameBtn={t('userAdministrationView.buttonTitle')}
                    iconAdd
                    onClickBtn={() => {
                      setNameComponentUser('Agregar usuario')
                      setShowDetails(true);
                    }}
                  />
                </div>
                <div className='userAdministrationView-searchHLPure'>
                  <SearchBarHLPure
                    placeholder={t(
                      'userAdministrationView.searchBarPlaceHolder'
                    )}
                    onSearchChange={(e) => searchChange(e)}
                  />
                </div>
                <div className='userAdministrationView-filterHLPure'>
                  <DropDownBtnHLPure
                    optionsDropDown={optionsFilter}
                    nameOption={'status'}
                    valueItem={'active'}
                    optionsValue={'todos'}
                    onDropDownChange={(e) => { filterChange(e) }}
                    iconFilter={true}
                  />
                </div>
              </div>

              <Grid item className="userAdministrationView-gridContainer">
                <GridHLPure
                  {...props}
                  dataGrid={dataUser}
                  skip={0}
                  take={6}
                  selectedValueFilter={selectedValueFilter}
                  titleRow1={t("userAdministrationView.grid.title.1")}
                  fieldRow1={"name"}
                  fieldTitle={"name"}
                  // titleRow2={"Acciones"}
                  fieldSubtitle={"email"}
                  fieldImg={"profilePicture"}
                  onFilterChange={filterChange}
                  onSelectedItem={setSelectedUser}
                  setShowDetails={setShowDetails}
                  setNameComponentUser={setNameComponentUser}
                  filter={true}
                  column2Status
                  field2Status={"active"}
                  title2Status={!isCompactView ? t('userAdministrationView.grid.title.2') : null}
                  columnThree={false}
                  iconColumnThree={false}
                  iconActiveThree={false}
                  columnFour={true}
                  titleRow4={t("userAdministrationView.grid.title.3")}
                  iconOneActive
                  iconTwoActive
                  iconThirdActive
                  iconFourthActive
                  iconFifthActive
                  activeDialogTrash
                  labelOneActions={t(
                    "userAdministrationView.grid.actions.assign.roles"
                  )}
                  labelTwoActions={t(
                    "userAdministrationView.grid.actions.assign.companies"
                  )}
                  labelThirdActions={t(
                    "userAdministrationView.grid.actions.disable"
                  )}
                  labelFourthActions={t(
                    "userAdministrationView.grid.actions.view.detail"
                  )}
                  labelFifthActions={t(
                    "administrateInvitedUsers.grid.actions.resendInvitation"
                  )}
                  styleCol1={"userAdministrationView-cellItemStylesCol1"}
                  styleCol2={"userAdministrationView-cellItemStylesCol2"}
                  styleCol3={"userAdministrationView-cellItemStylesCol3"}
                  styleCol4={"userAdministrationView-cellItemStylesCol4"}
                  widthHeaderCol1={"userAdministrationView-widthHeaderCol1"}
                  widthHeaderCol2={'userAdministrationView-widthHeaderCol2'}
                  widthHeaderCol3={"userAdministrationView-widthHeaderCol1"}
                  widthHeaderCol4={"userAdministrationView-widthHeaderCol1"}
                  widthHeaderGeneral={
                    "userAdministrationView-widthHeaderGeneral"
                  }
                  iconAvatar
                  btnOpenDialog1={false}
                  activeDialog1={false}
                  activeDialog5
                  btnOpenDialog5={handleResendInvitationClick}
                  showIconFiveCondition={(dataItem) => dataItem.showBtnReactive}
                  btnOpenDialogTrash={(dataItem) =>
                    handleShowDialogDelete(dataItem)
                  }
                />
              </Grid>
            </>
          )}
          {!nameComponentUser && (
            <Grid
              container
              style={{ justifyContent: "flex-end", paddingBottom: "20px" }}
            >
              <ButtonHLPure
                nameBtn={t("button.return")}
                onClickBtn={() => props.history.push("/configuration")}
              />
            </Grid>
          )}
          {showDialogDelete && (
            <DialogSystemGLPure
              showConfirm={true}
              confirmTitle={t("userAdministrationView.dialog.delete.title")}
              confirmMessage={t("userAdministrationView.dialog.delete.question")}
              labelCancelConfirmation={t('button.cancel')}
              handleConfirmDeleteFlowClose={() => handleCloseDialogDelete()}
              labelSubmitConfirmation={t('button.delete')}
              handleConfirmDeleteFlowSubmit={() => deleteUser()}
            />
          )}
          <DialogSystemGLPure
            showLoadingRequesting={props.showLoadingRequesting}
            showCompletedRequesting={props.showCompletedRequesting}
            showErrorRequesting={props.showErrorRequesting}
            showWarningRequesting={props.showWarningRequesting}
            toggleLoadingRequesting={props.toggleLoadingRequesting}
            toggleCompletedRequesting={props.toggleCompletedRequesting}
            toggleErrorRequesting={props.toggleErrorRequesting}
            toggleWarningRequesting={props.toggleWarningRequesting}
            message={props.message}
            showConfirm={showResendInvitationConfirm}
            confirmTitle={t('administrateInvitedUsers.resendInvitation.confirm.title')}
            confirmMessage={t('administrateInvitedUsers.resendInvitation.confirm.message')}
            handleConfirmDeleteFlowClose={handleResendInvitationClose}
            handleConfirmDeleteFlowSubmit={handleResendInvitationSubmit}
            labelCancelConfirmation={t('button.cancel')}
            labelSubmitConfirmation={t('button.confirm')}
          />
          <Grid item xs={12} lg={12} md={12} sm={12}>
            <PromotionalFooterPure />
          </Grid>
        </Container>
      )}
    </div>
  );
};

export default UserAdministrationView;
